import NumericalValueTile from '../core/NumericalTile/NumericalTile';
import { useFormattedMetricsValues } from '../core/NumericalTile/NumericalTile.utils';
import { MetricsTileComponent } from '../core/MetricsTile/MetricsTile';

export interface ISingleValueTileProps {
    previousValue?: number | null;
    currentValue?: number | null;
    formatter?: (val: number) => string;
    reverseTrend?: boolean;
    showTooltip?: boolean;
}

const SingleValueTile: MetricsTileComponent<ISingleValueTileProps> = ({
    title,
    previousValue,
    currentValue,
    formatter,
    reverseTrend,
    showTooltip,
    className,
}) => {
    const values = useFormattedMetricsValues(
        [
            {
                previous: previousValue,
                current: currentValue,
            },
        ],
        { valueFormatter: formatter, showValueTooltip: showTooltip }
    );

    return (
        <NumericalValueTile
            title={title}
            values={values}
            reverseTrend={reverseTrend}
            className={className}
        />
    );
};

export default SingleValueTile;
